(function () {
  var initializedAttribute = 'data-salford-signup-initialized';
  var copyInitializedAttribute = 'data-salford-copy-initialized';
  var giftInitializedAttribute = 'data-salford-gift-initialized';
  var giftCartSyncInitialized = false;
  var giftCartSyncTimeout = null;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function initForms(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll('[data-salford-signup-form]');

    forms.forEach(function (form) {
      if (form.hasAttribute(initializedAttribute)) {
        return;
      }

      form.setAttribute(initializedAttribute, 'true');
      form.addEventListener('submit', handleSubmit);
    });
  }

  function initCopyButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-salford-copy-code]');

    buttons.forEach(function (button) {
      if (button.hasAttribute(copyInitializedAttribute)) {
        return;
      }

      button.setAttribute(copyInitializedAttribute, 'true');
      button.addEventListener('click', handleCopyButton);
    });
  }

  function initGiftButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-salford-gift-add]');

    buttons.forEach(function (button) {
      if (button.hasAttribute(giftInitializedAttribute)) {
        return;
      }

      button.setAttribute(giftInitializedAttribute, 'true');
      button.addEventListener('click', handleGiftAdd);
    });

    if (buttons.length) {
      initGiftCartSync();
      syncGiftPickersWithCart();
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    var form = event.currentTarget;
    var emailInput = form.querySelector('[data-salford-signup-email]');
    var email = emailInput ? emailInput.value.trim() : '';

    clearStatus(form);

    if (!emailInput || !emailInput.checkValidity()) {
      if (emailInput) {
        emailInput.reportValidity();
      }
      return;
    }

    var companyId = getData(form, 'klaviyoCompanyId');
    var listId = getData(form, 'klaviyoListId');
    var errorMessage = getData(form, 'errorMessage') || 'Sorry, we could not sign you up. Please try again.';

    if (!companyId || !listId) {
      setStatus(form, 'Add a Klaviyo public site ID and list ID in the Theme Editor before this form can subscribe visitors.', 'error');
      return;
    }

    setLoading(form, true);

    submitToKlaviyo(form, email)
      .then(function () {
        var redirectUrl = getData(form, 'successRedirectUrl');

        if (redirectUrl) {
          window.location.assign(redirectUrl);
          return;
        }

        showSuccess(form);
      })
      .catch(function (error) {
        setStatus(form, error && error.message ? error.message : errorMessage, 'error');
      })
      .finally(function () {
        setLoading(form, false);
      });
  }

  function submitToKlaviyo(form, email) {
    var companyId = getData(form, 'klaviyoCompanyId');
    var listId = getData(form, 'klaviyoListId');
    var revision = getData(form, 'klaviyoRevision') || '2026-07-15';
    var sourceProperty = getData(form, 'signupSourceProperty') || 'signup_source';
    var sourceValue = getData(form, 'signupSource') || 'tumbler_mug_landing_page';
    var offerProperty = getData(form, 'signupOfferProperty') || 'signup_offer';
    var offerValue = getData(form, 'signupOffer') || 'free_mug_or_tumbler';
    var customSource = getData(form, 'customSource') || sourceValue;
    var properties = {};

    if (sourceProperty && sourceValue) {
      properties[sourceProperty] = sourceValue;
    }

    if (offerProperty && offerValue) {
      properties[offerProperty] = offerValue;
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                      consented_at: new Date().toISOString()
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        revision: revision
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (response.ok) {
        return;
      }

      return response.text().then(function (text) {
        var configuredMessage = getData(form, 'errorMessage') || 'Sorry, we could not sign you up. Please try again.';
        var apiMessage = extractKlaviyoError(text);
        throw new Error(apiMessage || configuredMessage);
      });
    });
  }

  function extractKlaviyoError(text) {
    if (!text) {
      return '';
    }

    try {
      var data = JSON.parse(text);

      if (data && data.errors && data.errors[0] && data.errors[0].detail) {
        return data.errors[0].detail;
      }

      if (data && data.message) {
        return data.message;
      }
    } catch (error) {
      return '';
    }

    return '';
  }

  function setLoading(form, isLoading) {
    var button = form.querySelector('[data-salford-signup-submit]');
    var loadingText = getData(form, 'loadingText') || 'Submitting...';

    form.classList.toggle('is-loading', isLoading);

    if (!button) {
      return;
    }

    if (!button.hasAttribute('data-original-text')) {
      button.setAttribute('data-original-text', button.textContent);
    }

    button.disabled = isLoading;
    button.textContent = isLoading ? loadingText : button.getAttribute('data-original-text');
  }

  function setStatus(form, message, state) {
    var status = form.querySelector('[data-salford-signup-status]');

    if (!status) {
      return;
    }

    status.textContent = message;
    status.setAttribute('data-state', state || 'info');
    status.removeAttribute('hidden');
  }

  function clearStatus(form) {
    var status = form.querySelector('[data-salford-signup-status]');

    if (!status) {
      return;
    }

    status.textContent = '';
    status.setAttribute('hidden', '');
    status.removeAttribute('data-state');
  }

  function showSuccess(form) {
    var root = form.closest('[data-salford-signup-form-root]');
    var success = root ? root.querySelector('[data-salford-signup-success]') : null;

    form.setAttribute('hidden', '');

    if (success) {
      root.classList.add('is-success-visible');
      var hero = root.closest('.salford-signup-hero');

      if (hero) {
        hero.classList.add('is-success-visible');
      }

      success.removeAttribute('hidden');
      success.focus();
    }
  }

  function handleCopyButton(event) {
    var button = event.currentTarget;
    var code = getData(button, 'salfordCopyCode');

    if (!code) {
      return;
    }

    copyText(code).then(function () {
      setCopyFeedback(button, 'Copied');
    }).catch(function () {
      setCopyFeedback(button, 'Copy');
    });
  }

  function handleGiftAdd(event) {
    var button = event.currentTarget;
    var picker = button.closest('[data-salford-gift-picker]');
    var status = picker ? picker.querySelector('[data-salford-gift-status]') : null;
    var shopSpirits = picker ? picker.querySelector('[data-salford-shop-spirits]') : null;
    var variantId = getData(button, 'variantId');
    var discountCode = getData(button, 'discountCode');
    var addedMessage = getData(button, 'addedMessage') || 'Gift added.';

    if (!variantId || button.disabled || (picker && (picker.hasAttribute('data-gift-pending') || picker.hasAttribute('data-gift-selected')))) {
      return;
    }

    if (picker) {
      picker.setAttribute('data-gift-pending', 'true');
    }

    var giftAdded = false;
    setGiftStatus(status, 'Adding your gift...', 'info');
    setGiftButtonsLoading(picker, button, true);

    addGiftToCart(variantId)
      .then(function () {
        return applyDiscountCode(discountCode);
      })
      .then(function () {
        giftAdded = true;
        lockGiftPicker(picker, button, variantId);
        setGiftStatus(status, addedMessage, 'success');

        if (shopSpirits) {
          shopSpirits.removeAttribute('hidden');
        }
      })
      .catch(function () {
        setGiftStatus(status, 'Sorry, we could not add that gift. Please try again.', 'error');
      })
      .finally(function () {
        if (picker) {
          picker.removeAttribute('data-gift-pending');
        }

        if (!giftAdded) {
          setGiftButtonsLoading(picker, button, false);
        }
      });
  }

  function addGiftToCart(variantId) {
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var body = {
      items: [{
        id: Number(variantId),
        quantity: 1
      }],
      sections: getCartSections().join(','),
      sections_url: window.location.pathname
    };

    return fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.ok) {
        return response.json();
      }

      throw new Error('Gift add failed.');
    }).then(function (cartState) {
      return refreshCart(cartState).then(function () {
        return cartState;
      });
    });
  }

  function cartTarget() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getCartSections() {
    var cart = cartTarget();

    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (section) {
        return section.id;
      }).filter(Boolean);
    }

    return ['cart-drawer', 'cart-icon-bubble', 'cart-notification-product', 'cart-notification-button'];
  }

  function refreshCart(cartState) {
    var cart = cartTarget();

    publishCartUpdate(cartState);

    if (cart && cartState && cartState.sections && typeof cart.renderContents === 'function') {
      if (cart.classList && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }

      cart.renderContents(cartState);
      return refreshCartBubble().then(function () {
        return openCart(cart);
      });
    }

    return Promise.all([refreshCartDrawer(), refreshCartBubble()])
      .then(function () {
        return openCart(cartTarget());
      });
  }

  function refreshCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';

    if (!cartDrawer) {
      return Promise.resolve();
    }

    return fetch(cartUrl + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (htmlText) {
        if (!htmlText) {
          return;
        }

        var html = new DOMParser().parseFromString(htmlText, 'text/html');
        var freshDrawer = html.querySelector('cart-drawer');

        if (freshDrawer) {
          cartDrawer.innerHTML = freshDrawer.innerHTML;
          cartDrawer.classList.remove('is-empty');
        }

        var drawerItems = document.querySelector('cart-drawer-items');

        if (drawerItems) {
          drawerItems.classList.remove('is-empty');
        }
      })
      .catch(function () {});
  }

  function refreshCartBubble() {
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    return fetch(rootPath + '?sections=cart-icon-bubble', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (sections) {
        if (!sections || !sections['cart-icon-bubble']) {
          return;
        }

        var parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var freshBubble = parsedBubble.querySelector('#shopify-section-cart-icon-bubble') || parsedBubble.getElementById('cart-icon-bubble');
        var liveBubble = document.querySelector('#shopify-section-cart-icon-bubble') || document.getElementById('cart-icon-bubble');

        if (freshBubble && liveBubble) {
          liveBubble.innerHTML = freshBubble.innerHTML;
        }
      })
      .catch(function () {});
  }

  function openCart(cart) {
    if (cart && typeof cart.open === 'function') {
      cart.open();
    }
  }

  function publishCartUpdate(cartState) {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        cart: cartState,
        source: 'salford-signup-gift-picker'
      }
    }));

    document.dispatchEvent(new CustomEvent('ajaxCart:updated', {
      bubbles: true,
      detail: {
        cart: cartState,
        source: 'salford-signup-gift-picker'
      }
    }));

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'salford-signup-gift-picker',
        cartData: cartState
      });
    }
  }

  function applyDiscountCode(discountCode) {
    if (!discountCode) {
      return Promise.resolve();
    }

    return fetch('/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart', {
      credentials: 'same-origin'
    }).then(function () {
      return;
    }).catch(function () {
      return;
    });
  }

  function initGiftCartSync() {
    if (giftCartSyncInitialized) {
      return;
    }

    giftCartSyncInitialized = true;

    document.addEventListener('cart:refresh', scheduleGiftCartSync);
    document.addEventListener('ajaxCart:updated', scheduleGiftCartSync);

    document.addEventListener('click', function (event) {
      if (event.target.closest('cart-remove-button, .cart-remove-button, [data-cart-remove], a[href*="/cart/change"], a[href*="/cart/clear"]')) {
        scheduleGiftCartSync();
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.closest('cart-drawer, cart-items, form[action*="/cart"]')) {
        scheduleGiftCartSync();
      }
    });
  }

  function scheduleGiftCartSync() {
    window.clearTimeout(giftCartSyncTimeout);
    giftCartSyncTimeout = window.setTimeout(syncGiftPickersWithCart, 900);
  }

  function syncGiftPickersWithCart() {
    var pickers = document.querySelectorAll('[data-salford-gift-picker]');

    if (!pickers.length) {
      return Promise.resolve();
    }

    return fetchCart()
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) {
          return;
        }

        pickers.forEach(function (picker) {
          syncGiftPickerWithCart(picker, cart);
        });
      });
  }

  function fetchCart() {
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    return fetch(rootPath + 'cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function syncGiftPickerWithCart(picker, cart) {
    var selectedVariantId = findSelectedGiftVariantId(picker, cart);

    if (selectedVariantId) {
      lockGiftPickerToVariant(picker, selectedVariantId);
      return;
    }

    if (picker.hasAttribute('data-gift-selected')) {
      unlockGiftPicker(picker);
    }
  }

  function findSelectedGiftVariantId(picker, cart) {
    var giftVariantIds = Array.prototype.slice.call(picker.querySelectorAll('[data-salford-gift-add]')).map(function (button) {
      return getData(button, 'variantId');
    }).filter(Boolean);

    var matchingItem = cart.items.find(function (item) {
      var itemVariantId = item.variant_id || item.id;

      return giftVariantIds.indexOf(String(itemVariantId)) !== -1;
    });

    return matchingItem ? String(matchingItem.variant_id || matchingItem.id) : '';
  }

  function setGiftButtonsLoading(picker, activeButton, isLoading) {
    if (!picker) {
      return;
    }

    var buttons = picker.querySelectorAll('[data-salford-gift-add]');

    buttons.forEach(function (button) {
      if (!button.hasAttribute('data-original-disabled')) {
        button.setAttribute('data-original-disabled', button.disabled ? 'true' : 'false');
      }

      button.disabled = isLoading || button.getAttribute('data-original-disabled') === 'true';
      button.classList.toggle('is-loading', isLoading && button === activeButton);
    });
  }

  function lockGiftPicker(picker, selectedButton, variantId) {
    if (!picker) {
      return;
    }

    picker.setAttribute('data-gift-selected', String(variantId));
    picker.classList.add('is-complete');

    picker.querySelectorAll('[data-salford-gift-add]').forEach(function (button) {
      button.disabled = true;
      button.classList.remove('is-loading');
      button.classList.toggle('is-selected', button === selectedButton);
    });
  }

  function lockGiftPickerToVariant(picker, variantId) {
    picker.setAttribute('data-gift-selected', String(variantId));
    picker.classList.add('is-complete');

    picker.querySelectorAll('[data-salford-gift-add]').forEach(function (button) {
      var isSelected = getData(button, 'variantId') === String(variantId);

      if (!button.hasAttribute('data-original-disabled')) {
        button.setAttribute('data-original-disabled', button.disabled ? 'true' : 'false');
      }

      button.disabled = true;
      button.classList.remove('is-loading');
      button.classList.toggle('is-selected', isSelected);
    });
  }

  function unlockGiftPicker(picker) {
    var status = picker.querySelector('[data-salford-gift-status]');
    var shopSpirits = picker.querySelector('[data-salford-shop-spirits]');

    picker.removeAttribute('data-gift-selected');
    picker.removeAttribute('data-gift-pending');
    picker.classList.remove('is-complete');

    picker.querySelectorAll('[data-salford-gift-add]').forEach(function (button) {
      button.disabled = button.getAttribute('data-original-disabled') === 'true';
      button.classList.remove('is-loading', 'is-selected');
    });

    setGiftStatus(status, '', 'info');

    if (shopSpirits) {
      shopSpirits.setAttribute('hidden', '');
    }
  }

  function setGiftStatus(status, message, state) {
    if (!status) {
      return;
    }

    status.textContent = message;
    status.setAttribute('data-state', state || 'info');
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');

      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        if (document.execCommand('copy')) {
          resolve();
        } else {
          reject(new Error('Copy command failed.'));
        }
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function setCopyFeedback(button, message) {
    var feedback = button.querySelector('[data-salford-copy-feedback]');

    if (!feedback) {
      return;
    }

    if (!feedback.hasAttribute('data-original-text')) {
      feedback.setAttribute('data-original-text', feedback.textContent);
    }

    feedback.textContent = message;

    window.clearTimeout(button.salfordCopyTimeout);
    button.salfordCopyTimeout = window.setTimeout(function () {
      feedback.textContent = feedback.getAttribute('data-original-text') || 'Copy';
    }, 1800);
  }

  function getData(element, key) {
    return element.dataset && element.dataset[key] ? element.dataset[key].trim() : '';
  }

  ready(function () {
    initForms(document);
    initCopyButtons(document);
    initGiftButtons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initForms(event.target);
    initCopyButtons(event.target);
    initGiftButtons(event.target);
  });
})();
